import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import VueRouter from 'vue-router';
import UUID from 'vue-uuid';




Vue.use(VueRouter);
Vue.use(UUID);

const routes = [
  {
    path: '/', component: () => import('./components/layout/NavBar.vue'),
    children: [
      { path: '', component: () => import('./components/Base64Encode.vue') },
      { path: '/base64-encode', component: () => import('./components/Base64Encode.vue') },
      { path: '/base64-decode', component: () => import('./components/Base64Decode.vue') },
      { path: '/url-encode', component: () => import('./components/URLEncode.vue') },
      { path: '/url-decode', component: () => import('./components/URLDecode.vue') },
      { path: '/jwt-decode', component: () => import('./components/JWTDecode.vue') },
      
      { path: '/what-is-my-ip', component: () => import('./components/WIMIP.vue') },
      
      { path: '/js-beautify', component: () => import('./components/JSBeautify.vue') },
      { path: '/css-beautify', component: () => import('./components/CSSBeautify.vue') },
      { path: '/html-beautify', component: () => import('./components/HTMLBeautify.vue') },
      
      { path: '/xml-beautify', component: () => import('./components/XMLBeautify.vue') },
      
      { path: '/md5-hash', component: () => import('./components/MD5Hash.vue') },
      { path: '/sha1-hash', component: () => import('./components/SHA1Hash.vue') },
      { path: '/sha256-hash', component: () => import('./components/SHA256Hash.vue') },
      { path: '/sha512-hash', component: () => import('./components/SHA512Hash.vue') },
    ]
  }
]

const router = new VueRouter({
  routes: routes,
  mode: 'history'
})

Vue.config.productionTip = false

new Vue({
  vuetify,
  router: router,
  render: h => h(App)
}).$mount('#app')
